import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import TableViews from 'components/organisms/TableViews/TableViews/TableViews';

const StyledEntitiesTableViews = styled(TableViews)`
  ${ComponentStyles}
`;

StyledEntitiesTableViews.propTypes = {
  theme: PropTypes.object
};

export default StyledEntitiesTableViews;
